import React, { useState, useRef, useEffect } from "react";
import { Ripple } from "primereact/ripple";

import { useUserContext } from "../contexts/UserContext";

const ProfileDropdownLinks = [
  { icon: "pi pi-power-off", label: "Logout", actionName: "logout" },
];

const ProfileDropdown = () => {
  const { user, isAuthenticated, logout } = useUserContext();

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  // Handle close on click outside
  const dropdownRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Handle menu item clicks
  const handleMenuItemClick = (actionName: string) => {
    switch (actionName) {
      case "logout":
        logout();
        break;
      default:
        break;
    }
  };

  return (
    <ul className="topbar-menu flex flex-row align-items-center">
      {isAuthenticated && user ? (
        <li className="profile-item static sm:relative" ref={dropdownRef}>
          <span
            className="flex flex-row align-items-center cursor-pointer p-2 border-round hover:surface-hover"
            tabIndex={1}
            onClick={() => setIsDropdownOpen((prev) => !prev)}
          >
            <img
              src={user?.picture || "/images/avatar/profile.jpg"}
              alt={user?.name || "My Profile"}
              className="profile-image w-2rem h-2rem border-circle"
            />
            <span className="pl-2 lg:profile-name text-gray-700">
              {user?.name || "My Profile"}
            </span>
          </span>
          <ul
            className={`bg-white list-none p-3 m-0 border-round shadow-2 absolute origin-top w-full sm:w-16rem mt-2 lg:right-0 z-50 ${
              isDropdownOpen ? "scalein" : "hidden"
            }`}
          >
            {ProfileDropdownLinks.map((item, index) => (
              <li key={`${item.label}-${index}`}>
                <span
                  onClick={(e) => {
                    e.preventDefault();
                    handleMenuItemClick(item.actionName);
                  }}
                  className="p-ripple flex p-2 border-round align-items-center hover:surface-hover transition-colors transition-duration-150 cursor-pointer w-full text-left"
                >
                  <i className={`${item.icon} mr-3`} />
                  <span className="font-semibold">{item.label}</span>
                  <Ripple />
                </span>
              </li>
            ))}
          </ul>
        </li>
      ) : (
        <li className="profile-item static sm:relative">
          <span className="profile-name text-gray-700">Not logged in</span>
        </li>
      )}
    </ul>
  );
};

export default ProfileDropdown;
